import auth from '@/request/auth'
import request from '@/request'
import handler from '@/utils/responseHandler'

function requestTicket(data = {}, login) {
  data.bizsys = data.bizsys ? data.bizsys : 'gtyy'
  data.pid = 651002

  if (data && data.eventAttr && (typeof data.eventAttr != 'string')) {
    data.eventAttr = JSON.stringify(data.eventAttr)
  }

  let params = {
    //url: '/gateway/adver/trace',
    url: '/gateway/hldm/trace',
    data,
    sidFields: ['pid', 'p', 'systemtime']
  }

  if (login) {
    params.auth = 'yes'
  }

  return request.ticket(params).then(handler.resBdData)
}

export default {
  /**
   * 用户数据埋点
   */
  '621000': (data = {}) => {
    return auth.get().then(() => {
      //登陆过
      data.forceLogin = 1

      return requestTicket(data, true)
    }).catch(() => {
      //未登陆
      return requestTicket(data)
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/eventTrack.js